import { Component, NgZone, ViewChild, ElementRef } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { UEData } from '../../providers/ue-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';

import { File } from '@ionic-native/file';
//import { Camera, CameraOptions } from '@ionic-native/camera';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { LicenseplateProvider } from '../../providers/licenseplate/licenseplate';
import { LicenseplateProviderNew } from '../../providers/licenseplate/licenseplate_new';

import { CameraPreview, CameraPreviewPictureOptions, CameraPreviewOptions, CameraPreviewDimensions } from '@ionic-native/camera-preview';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { ImageCroppedEvent, ImageCropperComponent, CropperPosition } from 'ngx-image-cropper';
//import { OpenALPR, OpenALPROptions, OpenALPRResult } from '@ionic-native/openalpr';

//declare var cordova : any;
declare var window: any;
@Component({
  selector: 'parkkontrollen-create',
  templateUrl: 'parkkontrollen-create.html'
})
export class ParkkontrollenCreatePage {
  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;  
  sNormalColor = "primary";  
  sCheckedColor = "secondary";

  sPressedButton = "";

  debug = "";
  autonummer = "";

  styleclass = "background-color-transparent";
  camerastarted = false;
  marke = "";
  farbe = "";
  halter = "";  

  oSelectedPP;
  imagesource;
  autonummern;
  picture="";

  imageChangedEvent: any = '';
  croppedImage: any = '';  
  imageBase64 = "";
  bShowCropper = true;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            //, public camera: Camera
            , public cameraPreview: CameraPreview
            , private base64ToGallery: Base64ToGallery
            //, public openALPR: OpenALPR
            , public file: File
            , public ueData: UEData
            , private lpProvider: LicenseplateProvider
            , private lpProviderNew: LicenseplateProviderNew
            ) {

              this.styleclass = "background-color-transparent";
              this.autonummern = [];
              this.autonummer = "";
   }

   ionViewDidLeave(){
    this.camerastarted = false;
    this.cameraPreview.stopCamera();
   }
   
   ionViewWilEnter(){

   }

   onDemo(){

    const cameraPreviewOpts: CameraPreviewOptions = {
      x: 25,
      y: 100,
      width: window.screen.width-50,//window.screen.width/2,
      height: 150,
      camera: 'rear',
      tapPhoto: false,
      previewDrag: true,
      toBack: false,
      alpha: 1
      //storeToFile: false
    };
    
    // start camera
    this.cameraPreview.startCamera(cameraPreviewOpts).then(
      (res) => {
        //console.log(res)
        this.camerastarted = true;
      },
      (err) => {
        console.log(err)
      });
      
      this.cameraPreview.show();
   }



   onTakePicture(){
    const pictureOpts: CameraPreviewPictureOptions = {
      width: 1024,
      height: 1024,
      quality: 40
    }  
    
    this.cameraPreview.takePicture(pictureOpts).then(async (imageData) => {
      //console.log(imageData);
      this.imagesource = imageData;
      this.bShowCropper = true;
      
       this.autonummer = "";
       //this.imageCropper.imageBase64 = imageData;
       this.imageBase64 = 'data:image/jpeg;base64,' + imageData;;


       console.log("remoteFindLicenseplate");
       //this.picture = 'data:image/jpeg;base64,' + imageData;
       this.lpProviderNew.remoteFindLicenseplate(imageData).then(async (data) => {

        this.autonummern.push(data["plate"]);
        this.autonummer = String(data["plate"]);
        
        let cp = {} as CropperPosition;
        let scale = (window.screen.width)/1024;
        scale = 0.465;
        console.log("scale: "+scale);
        cp.x1 = (data["box"].xmin * scale);
        cp.y1 = (data["box"].ymin * scale);
        cp.x2 = (data["box"].xmax * scale);
        cp.y2 = (data["box"].ymax * scale);
        
       /*
       cp.x1 = 0;
       cp.y1 = 0;
       cp.x2 = 200;
       cp.y2 = 100;
       */
        this.bShowCropper = false;
        this.imageCropper.cropper = cp;
        
        let image = await this.imageCropper.crop();
        //console.log(image);
        console.log(image.width);
        console.log(image.height);
        console.log(image.cropperPosition);
        console.log(image.imagePosition);
        console.log(image.offsetImagePosition);
        this.imageCropper.disabled = true;
        this.croppedImage = image.base64;

      });

      
    }, (err) => {
      console.log(err);
      //this.picture = 'assets/img/test.jpg';
    });  
    
   }

   fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }
    imageLoaded() {
        // show cropper
        console.log('image loaded');
    }
    cropperReady() {
        // cropper ready
        console.log('cropper ready');
    }
    loadImageFailed() {
        // show message
        console.log('loadImageFailed');
    }   



/**
 * Convert a base64 string in a Blob according to the data and contentType.
 * 
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */
 b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
  }

var blob = new Blob(byteArrays, {type: contentType});
return blob;
}

/**
* Create a Image file according to its database64 content only.
* 
* @param folderpath {String} The folder where the file will be created
* @param filename {String} The name of the file that will be created
* @param content {Base64 String} Important : The content can't contain the following string (data:image/png[or any other format];base64,). Only the base64 string is expected.
*/
 savebase64AsImageFile(folderpath,filename,content,contentType){
// Convert the base64 string in a Blob
var DataBlob = this.b64toBlob(content,contentType);

console.log("Starting to write the file :3");

window.resolveLocalFileSystemURL(folderpath, function(dir) {
  console.log("Access to the directory granted succesfully");
dir.getFile(filename, {create:true}, function(file) {
      console.log("File created succesfully.");
      file.createWriter(function(fileWriter) {
          console.log("Writing content to file");
          fileWriter.write(DataBlob);
      }, function(){
          alert('Unable to save file in path '+ folderpath);
      });
});
});
}


  
}



// WEBPACK FOOTER //
// ./src/pages/parkkontrollen/parkkontrollen-create.ts